import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, WrenchIcon, ShieldCheckIcon, CalendarClockIcon } from 'lucide-react';
export function Services() {
  const categories = [{
    title: 'Keep It Running',
    icon: WrenchIcon,
    items: ['Oil and filter service', 'Fluid checks and top-offs', 'Air and cabin filter replacement', 'Wiper blade replacement', 'Battery testing and replacement']
  }, {
    title: 'Keep It Safe',
    icon: ShieldCheckIcon,
    items: ['Brake inspection and service', 'Tire inspection, rotation, balancing, and alignment', 'Seasonal tire changeovers', 'Suspension inspection', 'Lights and visibility check']
  }, {
    title: 'Keep It on Track',
    icon: CalendarClockIcon,
    items: ['30K / 60K / 90K mileage service', 'Scheduled vehicle checkups', '47-point Digital Vehicle Inspection', 'High-mileage and 150K+ maintenance', 'Hybrid/EV battery inspection and service']
  }];
  return <section className="bg-brand-light px-4 py-20" data-id="element-134" data-mp="3b3zj8r2v5ai0">
      <div className="mx-auto max-w-6xl" data-id="element-135" data-mp="2xbrnn2nbfpkw">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-16 text-center" data-id="element-136" data-mp="2xd2td80bn7en">
          <img src="https://cdn.magicpatterns.com/uploads/v5w4cpb7uAJvjUTD8b3jRB/Lancer_Circle3x.png" alt="Lancer Service" className="mx-auto mb-8 h-36 w-36 object-contain drop-shadow-lg md:h-44 md:w-44" data-id="element-137" data-mp="3g32ddghb1wb7" />
          <span className="mb-4 block text-sm font-bold uppercase tracking-widest text-brand-accent" data-id="element-138" data-mp="24p71cglp63o7">
            WHAT WE TAKE CARE OF
          </span>
          <h2 className="mb-6 font-heading text-3xl font-extrabold uppercase tracking-wide text-brand-dark md:text-4xl lg:text-5xl" data-id="element-139" data-mp="1pj1840xivwt5">
            ONE SHOP. YOUR COMPLETE MAINTENANCE PROGRAM.
          </h2>
          <p className="mx-auto max-w-3xl text-lg text-gray-700 md:text-xl" data-id="element-140" data-mp="1gqqz2myd5xdh">
            From the basics that keep your car running day to day to the
            mileage-based services that keep bigger problems from developing —
            it all stays in one place, with people who know your vehicle.
          </p>
        </motion.div>

        <div className="mb-16 grid grid-cols-1 gap-8 md:grid-cols-3" data-id="element-141" data-mp="11wmft1pnc9hp">
          {categories.map((category, index) => {
          const Icon = category.icon;
          return <motion.div key={category.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="group overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-brand-accent/40 hover:shadow-xl" data-id="element-142" data-mp="svo7i786dftb" data-mpi={index}>
                <div className="flex items-center gap-4 bg-brand-accent px-6 py-5" data-id="element-143" data-mp="2btt62gcyeyd6">
                  <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-white/20" data-id="element-144" data-mp="2gqt361rtsqs5">
                    <Icon className="h-6 w-6 text-white" strokeWidth={2.4} data-id="element-145" data-mp="2lpw9dpjjl31p" />
                  </span>
                  <h3 className="font-heading text-xl font-extrabold uppercase leading-tight tracking-wide text-white md:text-2xl" data-id="element-146" data-mp="2pt2daqj6mi50">
                    {category.title}
                  </h3>
                </div>
                <ul className="space-y-3 p-6 md:p-8" data-id="element-147" data-mp="508laqn1cq9i">
                  {category.items.map(item => <li key={item} className="flex items-center gap-3 rounded-xl border border-transparent bg-brand-light px-4 py-3 transition-colors group-hover:border-gray-200" data-id="element-148" data-mp="3mz3bc2yl943">
                      <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-brand-accent/15" data-id="element-149" data-mp="8jg2r2flz9wh">
                        <CheckIcon className="h-4 w-4 text-brand-accent" strokeWidth={3} data-id="element-150" data-mp="mifpu5nh3gqj" />
                      </span>
                      <span className="text-base font-semibold text-brand-dark md:text-lg" data-id="element-151" data-mp="w88roextchhl">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center" data-id="element-152" data-mp="119g08g7s5kpb">
          <p className="mx-auto max-w-3xl text-xl font-bold text-brand-dark" data-id="element-153" data-mp="1avqwrefafe4j">
            Not sure where your car stands? Bring it in. We&apos;ll go through
            it and tell you exactly what&apos;s due, what&apos;s coming, and
            what can wait.
          </p>
          <a href="https://www.lancerservice.com/" target="_blank" rel="noopener noreferrer" className="mt-8 inline-flex items-center justify-center rounded-md bg-brand-accent px-8 py-4 font-bold text-white shadow-lg shadow-brand-accent/20 transition-colors hover:bg-brand-accentHover" data-id="element-154" data-mp="15y7kgk25hbf8">
            Schedule Maintenance →
          </a>
        </motion.div>
      </div>
    </section>;
}